export const StateName = 'ResponseSearchComponentState';

export interface ResponseSearchComponentState {
  searchTexts: { [key: string]: string };
}

export const initialState: ResponseSearchComponentState = {
  searchTexts: {}
};
